module.exports = __webpack_public_path__ + "img/MoDesk9.6213f2f8.png";